import { render, staticRenderFns } from "./cargoDocExtendCopyDialog.vue?vue&type=template&id=33e9dddd&"
import script from "./cargoDocExtendCopyDialog.vue?vue&type=script&lang=js&"
export * from "./cargoDocExtendCopyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33e9dddd')) {
      api.createRecord('33e9dddd', component.options)
    } else {
      api.reload('33e9dddd', component.options)
    }
    module.hot.accept("./cargoDocExtendCopyDialog.vue?vue&type=template&id=33e9dddd&", function () {
      api.rerender('33e9dddd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/edi/cargoDocExtendCopyDialog.vue"
export default component.exports